import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Card } from '@cargomatic/ui';
import { Package, X } from 'lucide-react';
import { getClassName } from '../../../utils/ui/classes';

const SIZE_CLASSES = {
  normal: 'w-40 h-40',
  small: 'w-32 h-32',
  auto: 'w-full h-40',
};

const AccessorialCard = ({
  selected,
  canSelect,
  canDelete,
  iconSlug,
  name,
  className,
  onSelect,
  onDelete,
  size,
}) => {
  function handleSelect(e) {
    if (!canSelect) {
      return;
    }
    e.preventDefault();
    onSelect();
  }

  function handleDelete(e) {
    e.stopPropagation();
    e.preventDefault();
    onDelete();
  }

  return (
    <div className={getClassName(className)}>
      <Card
        onClick={canSelect ? handleSelect : undefined}
        className={getClassName(
          [
            'relative',
            'flex',
            'items-center',
            'justify-center',
            'overflow-hidden',
            SIZE_CLASSES[size] || SIZE_CLASSES.normal,
          ],
          {
            'cursor-pointer transition-shadow hover:shadow-md': canSelect,
            'ring-2 ring-green border-green': selected,
          },
        )}
      >
        <div className="flex flex-col items-center justify-center w-full px-2">
          {iconSlug ? (
            <i className={getIconClass(iconSlug)} />
          ) : (
            <Package className="w-8 h-8 text-grey" />
          )}
          <span
            className="mt-2 text-center text-sm leading-tight break-words w-full"
            title={name}
          >
            {name}
          </span>
        </div>

        {canDelete && (
          <button
            type="button"
            className="absolute top-1 right-1 flex items-center justify-center w-6 h-6 rounded text-grey hover:text-grey-darker hover:bg-grey-lightest"
            onClick={handleDelete}
            aria-label="Delete"
          >
            <X className="w-4 h-4" />
          </button>
        )}
      </Card>
    </div>
  );
};

AccessorialCard.propTypes = {
  selected: PropTypes.bool,
  canSelect: PropTypes.bool,
  canDelete: PropTypes.bool,
  onDelete: PropTypes.func,
  onSelect: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  iconSlug: PropTypes.string,
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
    PropTypes.object,
  ]),
  size: PropTypes.string,
};

AccessorialCard.defaultProps = {
  selected: false,
  canSelect: false,
  canDelete: false,
  size: 'normal',
};

export default AccessorialCard;

function getIconClass(iconSlug) {
  const className = {
    'mx-0': true,
  };

  if (iconSlug) {
    className['icon-normal'] = true;
    className[iconSlug] = true;
  }

  return classnames(className);
}
